import "./App.css";
import "./index.css";
import React, { useState, useEffect } from "react";
import {
  Routes,
  Route,
  Navigate,
  useLocation,
  useNavigate,
} from "react-router-dom";
import setupAxiosInterceptors from "./api/axios";
import ProtectedRoute from "./components/protectedRoute";

import Home from "./pages/home/home";
import Greeting from "./pages/greeting/greeting";
import Overview from "./pages/overview/overView";
import NotFound from "./pages/notfound/notFound";
import UnderConstruction from "./pages/underconstruction/underConstruction";
import Members from "./pages/members/members";
import Organization from "./pages/organization/organization";
import Regulations from "./pages/regulations/regulations";
import CI from "./pages/ci/ci";
import Directions from "./pages/directions/directions";
import Notice from "./pages/notices/notice";
import NoticeDetail from "./pages/notices/noticeDetail";
import QnA from "./pages/qna/qna";
import QnADetail from "./pages/qna/qnaDetail";
import MembershipInfo from "./pages/membershipinfo/membershipInfo";
import Register from "./pages/register/register";
import Terms from "./pages/terms/terms";
import PaymentInfo from "./pages/paymentinfo/paymentInfo";
import Preparing from "./pages/preparing/preparing";
import NavigationBar from "./components/navbar";
import Footer from "./components/footer";
import Login from "./pages/login/login";
import MyPage from "./pages/mypage/myPage";

import DashBoard from "./pages/admin/dashboard/dashBoard";
import AdminNavbar from "./components/admin/navbar/adminNavbar";
import RegisterRequest from "./pages/admin/users/registerRequest";
import QnAWrite from "./pages/qna/qnaWrite";
import AdminNoticeWrite from "./pages/admin/notices/adminNoticeWrite";
import AdminNoticeList from "./pages/admin/notices/adminNoticeList";
import AdminNoticeDetail from "./pages/admin/notices/adminNoticeDetail";
import RegisterRequestDetail from "./pages/admin/users/adminUserDetail";
import AllUsers from "./pages/admin/users/allUsers";
import AdminUserDetail from "./pages/admin/users/adminUserDetail";
import Employment from "./pages/employment/employment";
import ApprovalRequest from "./pages/approvalrequest/approvalRequest";
import ApprovalRequestList from "./pages/admin/approval/approvalRequestList";
import ApprovalRequestAll from "./pages/admin/approval/approvalRequestAll";
import ApprovalRequestDetail from "./pages/admin/approval/approvalRequestDetail";
import UserApprovalRequests from "./pages/approvalrequest/approvalRequestList";
import UserApprovalRequestDetail from "./pages/approvalrequest/approvalRequestDetail";
import AdminSeminarsList from "./pages/admin/seminars/adminSeminarList";
import AdminSeminarDetail from "./pages/admin/seminars/adminSeminarDetail";
import AdminSeminarsWrite from "./pages/admin/seminars/adminSeminarsWrite";
import PreparingDetail from "./pages/preparing/preparingDetail";
import Project from "./pages/project/project";
import ProjectDetail from "./pages/project/projectDetail";
import AdminProjectsList from "./pages/admin/project/adminProjectList";
import AdminProjectDetail from "./pages/admin/project/adminProjectDetail";
import AdminProjectsWrite from "./pages/admin/project/adminProjectWrite";
import Education from "./pages/education/education";
import EducationDetail from "./pages/education/educationDetail";
import Scholarship from "./pages/scholarships/scholarship";
import ScholarshipDetail from "./pages/scholarships/scholarshipDetail";
import AdminEducationsList from "./pages/admin/educations/adminEducationList";
import AdminEducationDetail from "./pages/admin/educations/adminEducationDetail";
import AdminEducationsWrite from "./pages/admin/educations/adminEducationWrite";
import AdminScholarshipsList from "./pages/admin/scholarships/adminScholarshipList";
import AdminScholarshipDetail from "./pages/admin/scholarships/adminScholarshipDetail";
import AdminScholarshipsWrite from "./pages/admin/scholarships/adminScholarshipWrite";
import JobCenter from "./pages/jobcenter/jobCenter";
import JobCenterDetail from "./pages/jobcenter/jobCenterDetail";
import OtherBusiness from "./pages/otherbusiness/otherBusiness";
import OtherBusinessDetail from "./pages/otherbusiness/otherBusinessDetail";
import IndustryNews from "./pages/industrynews/industryNews";
import IndustryNewsDetail from "./pages/industrynews/industryNewsDetail";
import AdminJobCentersList from "./pages/admin/jocenter/adminJobCenterList";
import AdminJobCenterDetail from "./pages/admin/jocenter/adminJobCenterDetail";
import AdminJobCentersWrite from "./pages/admin/jocenter/adminJobCenterWrite";
import AdminOtherBusinesssList from "./pages/admin/otherbusiness/adminOtherBusinessList";
import AdminOtherBusinessDetail from "./pages/admin/otherbusiness/adminOtherBusinessDetail";
import AdminOtherBusinesssWrite from "./pages/admin/otherbusiness/adminOtherBusinessWrite";
import AdminIndustryNewssList from "./pages/admin/industrynews/adminIndustryNewsList";
import AdminIndustryNewsDetail from "./pages/admin/industrynews/adminIndustryNewsDetail";
import AdminIndustryNewssWrite from "./pages/admin/industrynews/adminIndustryNewsWrite";

function App() {
  const [user, setUser] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();
  const [alertMessage, setAlertMessage] = useState(null);
  const [isUserLoaded, setIsUserLoaded] = useState(false);

  // Axios Interceptor 설정
  useEffect(() => {
    setupAxiosInterceptors(navigate);
  }, [navigate]);

  // 초기 사용자 정보 로드
  useEffect(() => {
    const storedUser = sessionStorage.getItem("user");
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
    setIsUserLoaded(true);
  }, []);

  // 관리자 접근 보호
  const ProtectedAdminRoute = ({ children }) => {
    // 세션에서 사용자 정보 가져오기
    const storedUser = sessionStorage.getItem("user");
    const user = storedUser ? JSON.parse(storedUser) : null;

    // 로그인 확인
    if (!user) {
      if (!alertMessage) setAlertMessage("로그인 후 사용해주세요.");
      return <Navigate to="/login" state={{ from: location }} />;
    }

    // 권한 확인
    if (user.userType !== "ADMIN") {
      if (!alertMessage) {
        setAlertMessage("접근권한이 없는 계정입니다.");
      }
      return <Navigate to="/" />;
    }

    return children;
  };

  // 관리자 전용 페이지 목록
  const adminPaths = [
    "/admin",
    "/admin/notice/list",
    "/admin/notice/write",
    "/admin/user/register-request",
  ];
  const isAdminPage = adminPaths.some((path) =>
    location.pathname.startsWith(path)
  );

  // 네비게이션 바가 필요 없는 페이지 목록
  const noNavbarPaths = ["/login"];

  // `alertMessage` 변경 시 실행
  useEffect(() => {
    if (alertMessage) {
      alert(alertMessage);
      setAlertMessage(null); // 메시지 초기화
    }
  }, [alertMessage]);

  return (
    <div className="app-container">
      {/* 조건부 네비게이션 바 */}
      {!noNavbarPaths.includes(location.pathname) &&
        (isAdminPage ? <AdminNavbar /> : <NavigationBar />)}

      <div className="page-content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/greeting" element={<Greeting />} />
          <Route path="/overview" element={<Overview />} />
          <Route path="/members" element={<Members />} />
          <Route path="/organization" element={<Organization />} />
          <Route path="/regulations" element={<Regulations />} />
          <Route path="/ci" element={<CI />} />
          <Route path="/directions" element={<Directions />} />
          <Route path="/notice" element={<Notice />} />
          <Route path="/notice/:noticeId" element={<NoticeDetail />} />
          <Route path="/qna" element={<QnA />} />
          <Route path="/qna/:qnaId" element={<QnADetail user={user} />} />
          <Route
            path="/qna/write"
            element={<QnAWrite user={user} isUserLoaded={isUserLoaded} />}
          />
          <Route path="/membership-info" element={<MembershipInfo />} />
          <Route path="/register" element={<Register />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/payment-info" element={<PaymentInfo />} />
          <Route path="/seminars" element={<Preparing />} />
          <Route path="/seminar/:seminarId" element={<PreparingDetail />} />
          <Route path="/projects" element={<Project />} />
          <Route path="/project/:projectId" element={<ProjectDetail />} />
          <Route path="/education" element={<Education />} />
          <Route path="/education/:educationId" element={<EducationDetail />} />
          <Route path="/scholarships" element={<Scholarship />} />
          <Route
            path="/scholarship/:scholarshipId"
            element={<ScholarshipDetail />}
          />
          <Route path="/job-center" element={<JobCenter />} />
          <Route
            path="/job-center/:jobCenterId"
            element={<JobCenterDetail />}
          />
          <Route path="/other-business" element={<OtherBusiness />} />
          <Route
            path="/other-business/:otherBusinessId"
            element={<OtherBusinessDetail />}
          />
          <Route path="/industry-news" element={<IndustryNews />} />
          <Route
            path="/industry-news/:industryNewsId"
            element={<IndustryNewsDetail />}
          />
          <Route
            path="/my-page"
            element={
              <ProtectedRoute>
                <MyPage />
              </ProtectedRoute>
            }
          />
          <Route path="/employment" element={<Employment />} />
          <Route path="/approval-request" element={<ApprovalRequest />} />
          <Route
            path="/approval-request/list"
            element={<UserApprovalRequests />}
          />
          <Route
            path="/approval-request/detail/:approvalRequestId"
            element={<UserApprovalRequestDetail />}
          />
          <Route path="/login" element={<Login setUser={setUser} />} />
          <Route path="/under-construction" element={<UnderConstruction />} />
          <Route path="*" element={<NotFound />} />

          {/* 관리자 전용 경로 */}
          <Route
            path="/admin"
            element={
              <ProtectedAdminRoute>
                <DashBoard />
              </ProtectedAdminRoute>
            }
          />
          <Route
            path="/admin/notice/list"
            element={
              <ProtectedAdminRoute>
                <AdminNoticeList />
              </ProtectedAdminRoute>
            }
          />
          <Route
            path="/admin/notice/:noticeId"
            element={
              <ProtectedAdminRoute>
                <AdminNoticeDetail />
              </ProtectedAdminRoute>
            }
          />
          <Route
            path="/admin/notice/write"
            element={
              <ProtectedAdminRoute>
                <AdminNoticeWrite />
              </ProtectedAdminRoute>
            }
          />
          <Route
            path="/admin/seminar/list"
            element={
              <ProtectedAdminRoute>
                <AdminSeminarsList />
              </ProtectedAdminRoute>
            }
          />
          <Route
            path="/admin/seminar/:seminarId"
            element={
              <ProtectedAdminRoute>
                <AdminSeminarDetail />
              </ProtectedAdminRoute>
            }
          />
          <Route
            path="/admin/seminar/write"
            element={
              <ProtectedAdminRoute>
                <AdminSeminarsWrite />
              </ProtectedAdminRoute>
            }
          />
          <Route
            path="/admin/project/list"
            element={
              <ProtectedAdminRoute>
                <AdminProjectsList />
              </ProtectedAdminRoute>
            }
          />
          <Route
            path="/admin/project/:projectId"
            element={
              <ProtectedAdminRoute>
                <AdminProjectDetail />
              </ProtectedAdminRoute>
            }
          />
          <Route
            path="/admin/project/write"
            element={
              <ProtectedAdminRoute>
                <AdminProjectsWrite />
              </ProtectedAdminRoute>
            }
          />
          <Route
            path="/admin/education/list"
            element={
              <ProtectedAdminRoute>
                <AdminEducationsList />
              </ProtectedAdminRoute>
            }
          />
          <Route
            path="/admin/education/:educationId"
            element={
              <ProtectedAdminRoute>
                <AdminEducationDetail />
              </ProtectedAdminRoute>
            }
          />
          <Route
            path="/admin/education/write"
            element={
              <ProtectedAdminRoute>
                <AdminEducationsWrite />
              </ProtectedAdminRoute>
            }
          />
          <Route
            path="/admin/education/list"
            element={
              <ProtectedAdminRoute>
                <AdminProjectsList />
              </ProtectedAdminRoute>
            }
          />
          <Route
            path="/admin/education/:educationId"
            element={
              <ProtectedAdminRoute>
                <AdminProjectDetail />
              </ProtectedAdminRoute>
            }
          />
          <Route
            path="/admin/education/write"
            element={
              <ProtectedAdminRoute>
                <AdminProjectsWrite />
              </ProtectedAdminRoute>
            }
          />
          <Route
            path="/admin/scholarship/list"
            element={
              <ProtectedAdminRoute>
                <AdminScholarshipsList />
              </ProtectedAdminRoute>
            }
          />
          <Route
            path="/admin/scholarship/:scholarshipId"
            element={
              <ProtectedAdminRoute>
                <AdminScholarshipDetail />
              </ProtectedAdminRoute>
            }
          />
          <Route
            path="/admin/scholarship/write"
            element={
              <ProtectedAdminRoute>
                <AdminScholarshipsWrite />
              </ProtectedAdminRoute>
            }
          />
          <Route
            path="/admin/job-center/list"
            element={
              <ProtectedAdminRoute>
                <AdminJobCentersList />
              </ProtectedAdminRoute>
            }
          />
          <Route
            path="/admin/job-center/:jobCenterId"
            element={
              <ProtectedAdminRoute>
                <AdminJobCenterDetail />
              </ProtectedAdminRoute>
            }
          />
          <Route
            path="/admin/job-center/write"
            element={
              <ProtectedAdminRoute>
                <AdminJobCentersWrite />
              </ProtectedAdminRoute>
            }
          />
          <Route
            path="/admin/other-business/list"
            element={
              <ProtectedAdminRoute>
                <AdminOtherBusinesssList />
              </ProtectedAdminRoute>
            }
          />
          <Route
            path="/admin/other-business/:otherBusinessId"
            element={
              <ProtectedAdminRoute>
                <AdminOtherBusinessDetail />
              </ProtectedAdminRoute>
            }
          />
          <Route
            path="/admin/other-business/write"
            element={
              <ProtectedAdminRoute>
                <AdminOtherBusinesssWrite />
              </ProtectedAdminRoute>
            }
          />
          <Route
            path="/admin/industry-news/list"
            element={
              <ProtectedAdminRoute>
                <AdminIndustryNewssList />
              </ProtectedAdminRoute>
            }
          />
          <Route
            path="/admin/industry-news/:industryNewsId"
            element={
              <ProtectedAdminRoute>
                <AdminIndustryNewsDetail />
              </ProtectedAdminRoute>
            }
          />
          <Route
            path="/admin/industry-news/write"
            element={
              <ProtectedAdminRoute>
                <AdminIndustryNewssWrite />
              </ProtectedAdminRoute>
            }
          />
          <Route
            path="/admin/user/register-request"
            element={
              <ProtectedAdminRoute>
                <RegisterRequest />
              </ProtectedAdminRoute>
            }
          />
          <Route
            path="/admin/user/list"
            element={
              <ProtectedAdminRoute>
                <AllUsers />
              </ProtectedAdminRoute>
            }
          />
          <Route
            path="/admin/user/detail/:userId"
            element={
              <ProtectedAdminRoute>
                <AdminUserDetail />
              </ProtectedAdminRoute>
            }
          />
          <Route
            path="/admin/approval-request/request"
            element={
              <ProtectedAdminRoute>
                <ApprovalRequestList />
              </ProtectedAdminRoute>
            }
          />
          <Route
            path="/admin/approval-request/list"
            element={
              <ProtectedAdminRoute>
                <ApprovalRequestAll />
              </ProtectedAdminRoute>
            }
          />
          <Route
            path="/admin/approval-request/detail/:approvalRequestId"
            element={
              <ProtectedAdminRoute>
                <ApprovalRequestDetail />
              </ProtectedAdminRoute>
            }
          />
        </Routes>
      </div>

      {/* 관리자 페이지에는 Footer 제외 */}
      {!isAdminPage && <Footer />}
    </div>
  );
}

export default App;
